import FireIcon from "assets/icons/FireIcon";
import StarIcon from "assets/icons/StarIcon";
import SuccessIcon from "assets/icons/SuccessIcon";
import React, { FC, useCallback } from "react";
import { IHashTagsProps } from "types/components/hastags";

const iconsArr = [
  {
    name: "hot",
    icon: <FireIcon fill="red" />,
  },
  {
    name: "top",
    icon: <StarIcon fill="orange" />,
  },
  {
    name: "success",
    icon: <SuccessIcon fill="green" />,
  },
];
const Hashtags: FC<IHashTagsProps> = ({ hashtags, className }) => {
  const renderIcon = useCallback((name: string) => {
    return iconsArr.find((icon) => name.toLowerCase().includes(icon.name))
      ?.icon;
  }, []);

  const renderHashtags = useCallback((arr: string[]) => {
    return arr.map((item, idx) => (
      <div key={item} className={`flex items-center gap-2 text-theme-purple font-heebo ${idx !== 0 ? 'border-l border-l-theme-purple pl-2' : ''}`}>
        {renderIcon(item)} <p>{item}</p>
      </div>
    ));
  }, []);

  return (
    <div className={`flex gap-3 flex-wrap ${className || ""} | container`}>
      {renderHashtags(hashtags)}
    </div>
  );
};

export default Hashtags;
